// extracted by mini-css-extract-plugin
module.exports = {"section-title__title-container":"SectionTitle_section-title__title-container__3dHHY","section-title__title":"SectionTitle_section-title__title__1VskM"};